import { render, staticRenderFns } from "./NewProductOrService.vue?vue&type=template&id=68443f54&scoped=true"
import script from "./NewProductOrService.vue?vue&type=script&lang=js"
export * from "./NewProductOrService.vue?vue&type=script&lang=js"
import style0 from "./NewProductOrService.vue?vue&type=style&index=0&id=68443f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68443f54",
  null
  
)

export default component.exports